// extracted by mini-css-extract-plugin
export default {"text":"OVVpSk","large":"IXs8zV","medium":"nH8Th9","small":"bpCA8e","title":"SBmauO","bold":"mkGuJO","secondary":"Cxnyqm"};